// import { mutatorAction } from 'satcheljs';
import getAccountSourceListStore from "../store/accountSourceListStore";
import type { Contracts, CoprincipalAccountSource } from "../store/schema/AccountSourceList";
import { accountRankTypeChecker } from "../store/schema/AccountSourceList";

export type AccountContractUpdateCallback = (account: CoprincipalAccountSource) => Partial<Contracts> | undefined;

let contractUpdateCb: AccountContractUpdateCallback | undefined = undefined;

/**
 * Updates the contracts of a coprincipal account based on the currently registered
 * contract update callback (via `setCoprincipalAccountContractUpdateCallback`).
 * @param account Coprincipal account to update
 * @returns Account object with updated contracts
 */
export function updateCoprincipalAccountContracts(account: CoprincipalAccountSource): CoprincipalAccountSource {
    if (contractUpdateCb && accountRankTypeChecker.isCoprincipal(account)) {
        const updatedContracts = contractUpdateCb(account);
        if (updatedContracts) {
            return {
                ...account,
                contracts: {
                    ...account.contracts,
                    ...updatedContracts,
                },
            };
        }
    }
    
    return account;
}

/**
 * Updates the contracts of coprincipal accounts in the store based on a callback.
 * The callback should return undefined if no update is needed, otherwise an object
 * of contracts that need to be updated on the account. This will run for all accounts
 * currently in the store and newly added accounts in the future.
 * @param newContractUpdateCb Callback to compute updated contracts for coprincipal accounts
 */
export function setCoprincipalAccountContractUpdateCallback(newContractUpdateCb: AccountContractUpdateCallback): void {
    contractUpdateCb = newContractUpdateCb;
    
    getAccountSourceListStore().sources.forEach(account => {
        if (accountRankTypeChecker.isCoprincipal(account)) {
            const updatedContracts = newContractUpdateCb(account);
            if (updatedContracts) {
                account.contracts = {
                    ...account.contracts,
                    ...updatedContracts,
                };
            }
        }
    });
}
